/**
 * Scrolling Bar Promotion Web Component for Dawn Theme
 * Smooth, infinite marquee ticker with theme editor support
 */
if (!customElements.get('scrolling-bar-promotion')) {
  class ScrollingBarPromotion extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.scrolling-bar__track');
      this.observer = null;
      this.resizeTimeout = null;
    }

    connectedCallback() {
      this.initClones();
      this.setupObserver();
      this.setupThemeEditorEvents();
      window.addEventListener('resize', this.onResize.bind(this), { passive: true });
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('resize', this.onResize.bind(this));
    }

    initClones() {
      if (!this.track) return;
      const groups = this.track.querySelectorAll('.scrolling-bar__group');
      if (groups.length === 0) return;

      const firstGroup = groups[0];
      const singleGroupWidth = firstGroup.offsetWidth;

      // Only perform calculations if elements have rendered with width
      if (singleGroupWidth > 0) {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        const requiredWidth = viewportWidth * 2.5;
        let currentWidth = singleGroupWidth * this.track.querySelectorAll('.scrolling-bar__group').length;

        // If the current groups do not span 2.5x viewport, add clones
        let safetyCount = 0;
        while (currentWidth < requiredWidth && safetyCount < 20) {
          const clone = firstGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          // Remove shopify block attributes from clone so editor doesn't duplicate outlines
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
            el.removeAttribute('data-shopify-editor-block');
          });
          this.track.appendChild(clone);
          currentWidth += singleGroupWidth;
          safetyCount++;
        }
      }
    }

    onResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.initClones();
      }, 250);
    }

    setupObserver() {
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.classList.remove('is-paused');
            } else {
              this.classList.add('is-paused');
            }
          });
        },
        { rootMargin: '100px 0px 100px 0px' }
      );

      this.observer.observe(this);
    }

    setupThemeEditorEvents() {
      // Pause marquee when admin is selecting blocks in theme editor so it's easy to edit
      document.addEventListener('shopify:block:select', (event) => {
        if (this.contains(event.target)) {
          this.classList.add('is-paused');
        }
      });

      document.addEventListener('shopify:block:deselect', (event) => {
        if (this.contains(event.target)) {
          this.classList.remove('is-paused');
        }
      });
    }
  }

  customElements.define('scrolling-bar-promotion', ScrollingBarPromotion);
}
